import { DocumentDetailModel } from '../models/documentDetail'

export const PaymentDetail: DocumentDetailModel[] = [
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 1,
      name: 'เงินสด',
      description: 'เงินสด',
      code: 'CASH',
      isActive: true
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 2,
      name: 'เช็คธนาคาร',
      description: 'เช็คธนาคาร',
      code: 'CKC',
      isActive: true
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_HolderRelationship: '027',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 3,
      name: 'บัตรเครดิต',
      description: 'บัตรเครดิต',
      code: 'CC',
      isActive: true
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 4,
      name: 'อื่นๆ',
      description: 'อื่นๆ (โอนเงินสดเข้าบัญชีธนาคาร, เช็คสั่งจ่ายโดย FWD, นำเช็คเข้าบัญชีธนาคาร)',
      isActive: true
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 5,
      name: 'โอนเงินสดเข้าบัญชีธนาคาร',
      description: 'โอนเงินสดเข้าบัญชีธนาคาร',
      code: 'CASHPAYIN',
      isActive: false
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 6,
      name: 'นำเช็คเข้าบัญชีธนาคาร',
      description: 'นำเช็คเข้าบัญชีธนาคาร',
      code: 'CKCPAYIN',
      isActive: false
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    cheque_BankCode: '014', // hardcode
    paymentMethod: {
      id: 7,
      name: 'เช็คสั่งจ่ายโดย FWD',
      description: 'เช็คสั่งจ่ายโดย FWD',
      code: 'FWDCKC',
      isActive: false
    },
    isCheck: false
  },
  {
    paymentType: '',
    paymentAmount: 0,
    cheque_Bank: '',
    cheque_Branch: '',
    cheque_Number: '',
    cheque_Date: '',
    creditCard_HolderName: '',
    creditCard_Type: '',
    creditCard_Type_dcr: '',
    creditCard_Number: '',
    creditCard_ExpDate: '',
    other_Pay: '',
    paymentMethod: {
      id: 8,
      name: 'QR Code',
      description: 'QR Code',
      code: 'QRCODE',
      isActive: false
    },
    isCheck: false
  }
]

export const ReceiptUploadType = {
  PAY_IN: 'PAY_IN',
  SALE_SLIP: 'SALE_SLIP',
  SETTLEMENT_SLIP: 'SETTLEMENT_SLIP',
  PAY_IN_CKC: 'PAY_IN_CKC',
  FWD_CKC: 'FWD_CKC',
  OTHER: 'OTHER'
}

export const MapReceiptType = {
  PAY_IN: 'Pay in',
  SALE_SLIP: 'Sale Slip',
  SETTLEMENT_SLIP: 'Settlement Slip',
  PAY_IN_CKC: 'Pay in',
  FWD_CKC: 'FWD CKC',
  OTHER: 'เอกสารเพิ่มเติม'
}

export const MapCreditCardType = {
  BPT: 'BPT',
  EDC: 'EDC',
  KPT: 'KPT',
  MAS: 'Master',
  SPT: 'SPT',
  ULEDC: 'UL EDC',
  ULMAS: 'UL Master',
  ULVSA: 'UL VISA',
  VSA: 'VISA'
}
